export const config = {
  baseUrl: process.env.REACT_APP_GRAPHQL as string
}
